import "react";
import o from "../../../../_virtual/index.js";
import "react/jsx-runtime";
import { useDefaultProps as r } from "../../system/esm/DefaultPropsProvider/DefaultPropsProvider.js";
process.env.NODE_ENV !== "production" && (o.node, o.object.isRequired);
function i(e) {
  return r(e);
}
export {
  i as useDefaultProps
};
